import { FootballGameLogTypes } from '../models/football-game-log';
import { Locales } from './locales';

export const FootballGameLogTypeLocalization = {
  [Locales.ru]: {
    [FootballGameLogTypes.enter_game]: 'Выход на поле',
    [FootballGameLogTypes.exit_game]: 'Ушел с поля',
    [FootballGameLogTypes.shot_miss]: 'Удар мимо',
    [FootballGameLogTypes.shot_on_goal]: 'Удар в створ',
    [FootballGameLogTypes.shot_blocked]: 'Заблокированный удар',
    [FootballGameLogTypes.goal]: 'Гол',
    [FootballGameLogTypes.assist]: 'Передача',
    [FootballGameLogTypes.penalty_attempt]: 'Пенальти промах',
    [FootballGameLogTypes.penalty_goal]: 'Пенальти гол',
    [FootballGameLogTypes.small_penalty_attempt]: '10-метровый промах',
    [FootballGameLogTypes.small_penalty_goal]: '10-метровый гол',
    [FootballGameLogTypes.block_shot]: 'Блокировка удара',
    [FootballGameLogTypes.corner]: 'Угловой',
    [FootballGameLogTypes.free_kick]: 'Штрафной удар',
    [FootballGameLogTypes.save]: 'Отражен удар',
    [FootballGameLogTypes.penalty_save]: 'Отражен пенальти',
    [FootballGameLogTypes.small_penalty_save]: 'Отражен 10 метровый',
    [FootballGameLogTypes.foul]: 'Фол',
    [FootballGameLogTypes.yellow_card]: 'Желтая карточка',
    [FootballGameLogTypes.red_card]: 'Красная карточка',
    [FootballGameLogTypes.perfect_pass]: 'Пас',
    [FootballGameLogTypes.loss]: 'Потеря',
    [FootballGameLogTypes.steal]: 'Перехват',
    [FootballGameLogTypes.out]: 'Аут',
    [FootballGameLogTypes.timeout]: 'Таймаут',
    [FootballGameLogTypes.auto_goal]: 'Автогол',
    [FootballGameLogTypes.end_game_penalty_goal]: 'Пенальти гол',
    [FootballGameLogTypes.end_game_penalty_miss]: 'Пенальти промах',
    [FootballGameLogTypes.end_game_penalty_save]: 'Отражен пенальти',
    [FootballGameLogTypes.duel_won]: 'Дуэль выиграна',
    [FootballGameLogTypes.duel_lost]: 'Дуэль проиграна',
    [FootballGameLogTypes.double_goal]: 'Гол+2',
    [FootballGameLogTypes.super_game]: 'Супер игра',
    [FootballGameLogTypes.color_ball]: 'Цветной мяч',
    [FootballGameLogTypes.bonus]: 'Бонус',
  },
  [Locales.en]: {
    [FootballGameLogTypes.enter_game]: 'Entering the court',
    [FootballGameLogTypes.exit_game]: 'Exit the court',
    [FootballGameLogTypes.shot_miss]: 'Missing shot',
    [FootballGameLogTypes.shot_on_goal]: 'Shot on goal',
    [FootballGameLogTypes.shot_blocked]: 'Shot is blocked',
    [FootballGameLogTypes.goal]: 'Goal',
    [FootballGameLogTypes.assist]: 'Assist',
    [FootballGameLogTypes.penalty_attempt]: 'Penalty miss',
    [FootballGameLogTypes.penalty_goal]: 'Penalty goal',
    [FootballGameLogTypes.small_penalty_attempt]: '10-meters shot miss',
    [FootballGameLogTypes.small_penalty_goal]: '10-meters goal',
    [FootballGameLogTypes.block_shot]: 'Blocking shot',
    [FootballGameLogTypes.corner]: 'Corner',
    [FootballGameLogTypes.free_kick]: 'Free kick',
    [FootballGameLogTypes.save]: 'Save',
    [FootballGameLogTypes.penalty_save]: 'Penalty save',
    [FootballGameLogTypes.small_penalty_save]: '10-meters save',
    [FootballGameLogTypes.foul]: 'Foul',
    [FootballGameLogTypes.yellow_card]: 'Yellow card',
    [FootballGameLogTypes.red_card]: 'Red card',
    [FootballGameLogTypes.perfect_pass]: 'Pass',
    [FootballGameLogTypes.loss]: 'Loss',
    [FootballGameLogTypes.steal]: 'Steal',
    [FootballGameLogTypes.out]: 'Out',
    [FootballGameLogTypes.timeout]: 'Timeout',
    [FootballGameLogTypes.auto_goal]: 'Own goal',
    [FootballGameLogTypes.end_game_penalty_goal]: 'Penalty goal',
    [FootballGameLogTypes.end_game_penalty_miss]: 'Penalty miss',
    [FootballGameLogTypes.end_game_penalty_save]: 'Penalty save',
    [FootballGameLogTypes.duel_won]: 'Duel won',
    [FootballGameLogTypes.duel_lost]: 'Duel lost',
    [FootballGameLogTypes.double_goal]: 'Goal+2',
    [FootballGameLogTypes.super_game]: 'Super game',
    [FootballGameLogTypes.color_ball]: 'Color ball',
    [FootballGameLogTypes.bonus]: 'Bonus',
  }
};
